export enum UserDisplayFormatType {
  FULL_NAME = '',
  SHORTENED_FIRST_NAME = 'SHORTENED_FIRST_NAME',
  SHORTENED_LAST_NAME = 'SHORTENED_LAST_NAME',
  INITIALS_ONLY = 'INITIALS_ONLY'
}
